<style scoped lang="scss">
@import '~variables';
.btn {
    color: $white;
    margin-left: 0 !important;
    white-space: nowrap;
}
</style>

<template>
    <div>
        <a :href="href" class="btn btn-success m-1">
            <span class="fas fa-plus mr-1"></span>
            <slot></slot>
        </a>
    </div>
</template>

<script>
    export default {

        props: {
            href: String,
        },

    }
</script>
